import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import _ from 'lodash' 
import { Link } from 'react-router-dom'
import { packbuyoutput } from '../actions'
import { withAuthenticator } from 'aws-amplify-react'

class PackBuyComp extends Component {
  componentDidMount(){ 
    const {params} = this.props.match
    //console.log(params.id)
    this.props.packbuyoutput({set_name:params.id})
  } 
  renderEvents(){
    return _.map(this.props.openpackevent,event =>
        <img src={`https://mtg.www.montamanet.com/cards/${event.multiverse_id}.png`}/>
    )
  }
  render() {
    return (
      <div>
        You got the cards in the list below.<br />
        {this.renderEvents()} 
      </div>
      )
  }
}
const mapStateToProps = state => ({ openpackevent: state.openpackevent}) 
const mapDispatchToProps = ({ packbuyoutput })  
export default withAuthenticator(connect(mapStateToProps, mapDispatchToProps)(PackBuyComp))

